<template>
  <section class="app-offices">
    <integration-steps :current-step="2" />

    <article class="app-offices__wrapper">
      <div class="app-offices__col">
        <h5 class="app-offices__title">
          Selecione os consultórios para integrar ao
          Marketplace Dr. Conecta e ativar sua Agenda Online
        </h5>

        <div
          v-click-outside="() => ui.showOfficesList = false"
          class="app-offices__offices"
        >
          <div
            :class="ui.showOfficesList && 'app-offices__picker--active'"
            class="app-offices__picker"
            @click="ui.showOfficesList = !ui.showOfficesList"
          >
            <div
              v-show="chosenOffices.length === 0"
              class="app-offices__picker-none"
            >
              <span>Clique aqui para escolher seus consultórios</span>
            </div>

            <div
              v-show="chosenOffices.length > 0"
              class="app-offices__picked"
            >
              <div
                v-for="item in chosenOffices"
                :key="`chosenOffice-${item}`"
                class="app-offices__chip"
              >
                <span>{{ getOfficeName(item) }}</span>

                <span>
                  <i
                    class="icon icon-cross"
                    @click.self.stop="checkOption(item, chosenOffices)"
                  />
                </span>
              </div>
            </div>

            <span
              :class="ui.showOfficesList && 'app-offices__picker-icon--reverse'"
              class="app-offices__picker-icon"
            >
              <i class="icon icon-caret" />
            </span>
          </div>

          <transition name="fade">
            <ul
              v-if="ui.showOfficesList"
              class="app-offices__list"
            >
              <li
                v-for="office in doctorOffices"
                :key="`office-list-item-${office.id}`"
                :class="chosenOffices.includes(office.id) && 'app-offices__list-item--checked'"
                class="app-offices__list-item"
                @click="checkOption(office.id, chosenOffices)"
              >
                <span>{{ office.name }}</span>

                <transition name="fade">
                  <span v-show="chosenOffices.includes(office.id)">
                    <i class="icon icon-check" />
                  </span>
                </transition>
              </li>
            </ul>
          </transition>
        </div>
      </div>

      <div class="app-offices__col">
        <h5 class="app-offices__title">
          Deseja ativar o módulo Telemedicina?
        </h5>

        <div class="app-offices__text">
          <dr-switch
            v-model="isChecked"
            label-checked="Sim, quero atender através de Telemedicina"
            label-unchecked="Não, não quero atender através de Telemedicina"
            id="telemedicina-switch"
          />
        </div>
      </div>
    </article>

    <footer class="app-integration__footer">
      <button
        :disabled="chosenOffices.length === 0 && !isChecked"
        class="btn btn-primary app-integration__submit"
        @click="nextStep()"
      >
        Próximo
      </button>
    </footer>
  </section>
</template>

<script>
import integrationSteps from './integrationSteps'
import DrSwitch from '@/components/form/switch'
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'AppIntegrationOffices',

  components: {
    integrationSteps,
    DrSwitch
  },

  props: {
    doctor: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  data () {
    return {
      chosenOffices: [],
      isChecked: true,
      ui: {
        showOfficesList: false
      }
    }
  },

  computed: {
    ...mapGetters({
      appIntegration: 'getAppIntegration',
      plan: 'getPlan'
    }),

    doctorOffices () {
      return this.doctor['doctor_offices']
        .filter(office => /facetoface/gi.test(office.type))
    }
  },

  // watch: {
  //   isChecked: {
  //     deep: false,
  //     immediate: false,
  //     handler (next) {
  //       if (next && this.plan.isPro) {
  //         this.$store.dispatch('togglePlanModal', { showModal: true })
  //         this.$nextTick(() => {
  //           this.isChecked = false
  //         })
  //       }
  //     }
  //   }
  // },

  mounted () {
    this.fn_HIDE_PROGRESS()

    if (this.appIntegration && this.appIntegration['doctor_offices'].length > 0) {
      this.appIntegration['doctor_offices']
        .forEach(office => {
          if (/facetoface/gi.test(office.type)) {
            this.checkOption(office.id, this.chosenOffices)
          }

          if (/telemedicine/gi.test(office.type)) {
            this.isChecked = true
          }

          if (this.plan.isPro) {
            this.isChecked = false
          }
        })
    }
  },

  methods: {
    nextStep () {
      const isChecked = this.isChecked
      const offices = [...this.doctor['doctor_offices']
        .filter(office => this.chosenOffices.includes(office.id))]

      if (isChecked) {
        const previousTelemedicineOffice = this.doctor['doctor_offices']
          .find(office => /telemedicine/gi.test(office.type)) || null

        if (previousTelemedicineOffice) {
          offices.push(previousTelemedicineOffice)
        }
      }

      EventBus.$emit('app-integration-pick-offices', { isChecked, offices })
    },

    getOfficeName (item) {
      return this.doctorOffices.find(office => office.id === item).name || false
    },

    checkOption (item, list) {
      if (list.includes(item)) {
        list.splice(list.indexOf(item), 1)
      } else {
        list.push(item)
      }
    }
  }
}
</script>
